// @flow

import moment from 'moment';

import ApiObject from './ApiObject';

export default class Timelapse extends ApiObject {

  /**
   * Default fromTime / toTime value to indicate an non init timestamp.
   * @type {number}
   */
  static DEFAULT_VALUE = -1;

  _fromTime: number;
  _toTime: number;

  constructor() {
    super();

    this.setFromTime(moment().subtract(1, 'months').unix()); // 1 months before now
    this.setToTime(moment().unix());
  }

  setFromTime(givenValue: number) {
    const newValue = parseInt(givenValue, 10);
    if (newValue.toString().length > 11) {
      console.error('time set to ms', newValue);
    }
    // we set the new value as a timestamp in seconds.
    this._fromTime = newValue;
  }

  setToTime(givenValue: number) {
    const newValue = parseInt(givenValue, 10);
    if (newValue.toString().length > 11) {
      console.error('time set to ms', newValue);
    }
    // we set the new value as a timestamp in seconds.
    this._toTime = newValue;
  }

  getFromTime(): number {
    return this._fromTime;
  }

  getToTime(): number {
    return this._toTime;
  }

  getFromTimeAsDate(): Object {
    return moment(this.getFromTime(), 'X'); // 'X' -> Unix timestamp
  }

  getToTimeAsDate(): Object {
    return moment(this.getToTime(), 'X'); // 'X' -> Unix timestamp
  }

  // -- milliseconds timestamp

  getFromTimeAsMilliseconds() {
//    return this.getFromTimeAsDate().valueOf();
    return this.getFromTimeAsDate().valueOf();
  }

  getToTimeAsMilliseconds() {
    return this.getToTimeAsDate().valueOf();
  }

  // -- seconds timestamp

  getFromTimeAsSeconds() {
    return this.getFromTimeAsDate().unix();
  }

  getToTimeAsSeconds() {
    //    return this.getToTimeAsDate().valueOf();
    return this.getToTimeAsDate().unix();
  }

  // -- format

  getFromTimeAsFormattedDate(format: string = 'DD/MM/Y'): string {
    return this.getFromTimeAsDate().format(format);
  }

  getToTimeAsFormattedDate(format: string = 'DD/MM/Y'): string {
    return this.getToTimeAsDate().format(format);
  }

  // -- utils

  isSameDay(): boolean {
    const diff = this.getFromTimeAsDate().diff(this.getToTimeAsDate(), 'days');
    return diff === 0;
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/Timelapse.js